import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail, Check } from 'lucide-react';
export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setErrorMessage('');
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbz7HaXEfYoJMvTcHYJQvp7o-pWXJcI8nI685_TzC65Xeh3xStC2dcyf07mvqzw1CklO/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email
        })
      });
      // With no-cors mode, we can't read the response, so we assume success
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
      setErrorMessage('Something went wrong. Please try again.');
      console.error('Newsletter signup error:', error);
    }
  };
  return <section className="py-24 px-6 relative overflow-hidden bg-[#111]" data-id="element-83" data-mp="hgdftlk0wjb8">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')] mix-blend-overlay pointer-events-none" data-id="element-84" data-mp="cgh93ejxydrz" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-85" data-mp="3guyxnh7xerxo">
        {/* Social Links */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center gap-6 mb-16" data-id="element-86" data-mp="3gxbnegjxe6la">
          <motion.a href="https://www.yelp.com/biz/grounded-livermore-livermore" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1,
          y: -2
        }} className="flex flex-col items-center gap-2 group" data-id="element-87" data-mp="154mu82ewq4sc">
            <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-[#D97E3A] group-hover:bg-[#D97E3A]/10 transition-all" data-id="element-88" data-mp="1m4po95r9hn9h">
              <svg className="w-8 h-8 text-white/80 group-hover:text-[#D97E3A] transition-colors" viewBox="0 0 24 24" fill="currentColor" data-id="element-89" data-mp="tjy3xlpb9xeg">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm5.395 14.789l-1.524.232c-.171.026-.308-.139-.239-.289l.938-2.047c.069-.15-.013-.326-.171-.368l-2.171-.579c-.158-.042-.263-.197-.237-.355l.342-2.079c.026-.158-.092-.303-.25-.303h-2.166c-.158 0-.276.145-.25.303l.342 2.079c.026.158-.079.313-.237.355l-2.171.579c-.158.042-.24.218-.171.368l.938 2.047c.069.15-.068.315-.239.289l-1.524-.232c-.171-.026-.329.105-.329.276v1.842c0 .171.158.302.329.276l7.048-1.079c.171-.026.329-.158.329-.329v-1.71c0-.171-.158-.302-.329-.276z" data-id="element-90" data-mp="13ezr4c010pee" />
              </svg>
            </div>
            <span className="text-xs font-bebas tracking-wide text-white/60 group-hover:text-[#D97E3A] transition-colors" data-id="element-91" data-mp="3ugidsf2itoa5">
              YELP
            </span>
          </motion.a>

          <motion.a href="https://share.google/0d4dRWEqeCgdSEN99" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1,
          y: -2
        }} className="flex flex-col items-center gap-2 group" data-id="element-92" data-mp="3lfad5qcj8bcw">
            <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-[#D97E3A] group-hover:bg-[#D97E3A]/10 transition-all" data-id="element-93" data-mp="36qnzru6gttob">
              <svg className="w-8 h-8 text-white/80 group-hover:text-[#D97E3A] transition-colors" viewBox="0 0 24 24" fill="currentColor" data-id="element-94" data-mp="2xoog0u42gbho">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" data-id="element-95" data-mp="3rd42p7lqgobw" />
              </svg>
            </div>
            <span className="text-xs font-bebas tracking-wide text-white/60 group-hover:text-[#D97E3A] transition-colors" data-id="element-96" data-mp="3hlpwkgza0q9s">
              GOOGLE
            </span>
          </motion.a>

          <motion.a href="https://www.facebook.com/profile.php?id=100091558104133" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1,
          y: -2
        }} className="flex flex-col items-center gap-2 group" data-id="element-97" data-mp="38opest6ppqfb">
            <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-[#D97E3A] group-hover:bg-[#D97E3A]/10 transition-all" data-id="element-98" data-mp="wxv4zoxbh8oc">
              <svg className="w-8 h-8 text-white/80 group-hover:text-[#D97E3A] transition-colors" viewBox="0 0 24 24" fill="currentColor" data-id="element-99" data-mp="2hdjftfo3kf6r">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-100" data-mp="2mez3zglkn1td" />
              </svg>
            </div>
            <span className="text-xs font-bebas tracking-wide text-white/60 group-hover:text-[#D97E3A] transition-colors" data-id="element-101" data-mp="3a39ze48i09a9">
              FACEBOOK
            </span>
          </motion.a>

          <motion.a href="https://www.instagram.com/groundedlivermore/" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.1,
          y: -2
        }} className="flex flex-col items-center gap-2 group" data-id="element-102" data-mp="1frlfrorbnijj">
            <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-[#D97E3A] group-hover:bg-[#D97E3A]/10 transition-all" data-id="element-103" data-mp="3ftl0xs4y7jyd">
              <svg className="w-8 h-8 text-white/80 group-hover:text-[#D97E3A] transition-colors" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-104" data-mp="3ouj82jaoo7l6">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-105" data-mp="7fcdszl73ldl" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-106" data-mp="cbjnn3gpph0t" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-107" data-mp="gepplywskm1h" />
              </svg>
            </div>
            <span className="text-xs font-bebas tracking-wide text-white/60 group-hover:text-[#D97E3A] transition-colors" data-id="element-108" data-mp="ldsvflkliwai">
              INSTAGRAM
            </span>
          </motion.a>
        </motion.div>

        {/* Newsletter Section */}
        <div className="text-center" data-id="element-109" data-mp="20xti908mrfp0">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-110" data-mp="1wtlqsvasfln3">
            <div className="flex justify-center mb-6" data-id="element-111" data-mp="2kkhq0dhkpj4d">
              <Mail className="text-[#D97E3A] w-12 h-12" strokeWidth={1.5} data-id="element-112" data-mp="2fsg2twiva7zk" />
            </div>

            <h2 className="font-bebas text-6xl md:text-8xl text-white mb-4 leading-[0.9]" data-id="element-113" data-mp="2auemvkgqmosb">
              STAY <span className="text-[#D97E3A]" data-id="element-114" data-mp="389si76kuy56w">CONNECTED</span>
            </h2>

            <p className="font-inter text-white/60 text-lg max-w-xl mx-auto mb-10" data-id="element-115" data-mp="33ik808bpefso">
              Join our community for updates on new roasters, local drops,
              events, and coffee culture in Livermore.
            </p>

            {status === 'success' ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-[#D97E3A]/10 border border-[#D97E3A] p-8 rounded-lg max-w-md mx-auto" data-id="element-116" data-mp="2gn0m2dpwz1oy">
                <div className="flex flex-col items-center gap-4 text-[#D97E3A]" data-id="element-117" data-mp="2zl3cmwy416ov">
                  <div className="bg-[#D97E3A] text-white p-3 rounded-full" data-id="element-118" data-mp="2ll2ehp98cdd3">
                    <Check size={24} data-id="element-119" data-mp="2ln52k3qtnwf6" />
                  </div>
                  <h3 className="font-bebas text-2xl tracking-wide" data-id="element-120" data-mp="2pl2qz4crqehi">
                    YOU'RE ON THE LIST!
                  </h3>
                  <p className="text-white/80 font-inter text-sm" data-id="element-121" data-mp="1a7q8b7pzzinr">
                    Thanks for joining our community.
                  </p>
                </div>
              </motion.div> : <form onSubmit={handleSubmit} className="max-w-md mx-auto relative" data-id="element-122" data-mp="16pizpzr2442s">
                <div className="relative group" data-id="element-123" data-mp="1gmf72257yk5r">
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="w-full bg-white/5 border border-white/10 text-white px-6 py-5 pr-16 focus:outline-none focus:border-[#D97E3A] focus:bg-white/10 transition-all font-inter placeholder:text-white/30" required data-id="element-124" data-mp="1gl4424jllgfp" />
                  <button type="submit" disabled={status === 'loading'} className="absolute right-2 top-2 bottom-2 bg-[#D97E3A] text-white px-4 hover:bg-[#c06b2e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center" aria-label="Subscribe" data-id="element-125" data-mp="svjbctxn74t8">
                    {status === 'loading' ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-126" data-mp="2jcudaclij5oo" /> : <ArrowRight size={20} data-id="element-127" data-mp="29hak3xyc2l3m" />}
                  </button>
                </div>
                {status === 'error' && <p className="mt-4 text-sm text-red-400 font-inter" data-id="element-128" data-mp="24j91tf8qept7">
                    {errorMessage}
                  </p>}
                <p className="mt-4 text-xs text-white/30 font-inter" data-id="element-129" data-mp="1vob845xrf90t">
                  We respect your inbox. No spam, just good coffee.
                </p>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}